module.exports = __webpack_public_path__ + "static/school_support_reference@2x-4115f34d6fa3c23bab4631792a4ecfb6.png";